import BigCalendar from "react-big-calendar"

BigCalendar.tz = moment.tz.guess()
const m = (...args) => moment.tz(...args, BigCalendar.tz)
m.localeData = moment.localeData

BigCalendar.setLocalizer(
  BigCalendar.momentLocalizer(m)
)

import withTimezoneAwareness from "./withTimezoneAwareness"
export { withTimezoneAwareness }

export default BigCalendar



// WEBPACK FOOTER //
// ./app/webpack/frontend/lib/react-big-calendar/index.js